import React, { useEffect, useState } from "react";

import { NotifyConfirm } from "src/components/notify/Notify";
import Pagination from "src/components/Pagination/Pagination";
import { path } from "src/constants/path";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import useControlPanel from "src/hooks/useControlPanel";
import useDebounce from "src/hooks/useDebounce";
import { isOpenPopup } from "src/utils/isOpenPopup";
import {
  createIotCallingCampaign,
  getIotCallingCampaign,
  removeIotCallingCampaign,
  updateIotCallingCampaign,
} from "src/apis/CMS/iotCallingCampaign.api";
import IotCallingPopupCampaign from "../../components/Popup/IotCallingCampaignPopup";
import IotCallingCampaignControlPanel from "../../components/ControlPanel/IotCallingCampaignControlPanel";
import ControlPanelSystem from "src/components/controlPanelSystem/ControlPanelSystem";
import IotCallingCampaignTable from "../../components/Table/IotCallingCampaignTable";

const initIotCallingCampaignData = {
  list: [],
  total_record: 1,
};

const titlePage = "Iot Calling Campaign";

const IotCallingCampaign = () => {
  const permissionsAccessControl = useGetPermissionAccessControl();

  const {
    page,
    searchKey,
    numberPage,
    setNumberPage,
    limit,
    setLimit,
    status,
    setStatus,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    handleInputChange,
    handleChangePage,
  } = useControlPanel();

  const [iotCallingCampaignData, setIotCallingCampaignData] = useState(
    initIotCallingCampaignData
  );
  const [filterIotCallingCampaigns, setFilterIotCallingCampaigns] = useState(
    []
  );

  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);

  const [errorsForm, setErrorsForm] = useState({});

  let search = useDebounce(searchKey, 500);

  useEffect(() => {
    const query = {
      page: numberPage,
      limit,
      searchKey: search,
      startDate,
      endDate,
      status,
    };

    getIotCallingCampaign(query, (result) => {
      setIotCallingCampaignData({ ...result });
      setFilterIotCallingCampaigns([...result.list]);
    });
  }, [endDate, limit, numberPage, search, startDate, status]);

  useEffect(() => {
    setNumberPage(page);
  }, [page, setNumberPage, status]);

  const actionAfterCreateOrUpdate = (result, callback) => {
    if (result.data?.status === 422) {
      setErrorsForm({ ...result.data.data });
    } else {
      getIotCallingCampaign({}, (result) => {
        setIotCallingCampaignData({ ...result });
        setFilterIotCallingCampaigns([...result.list]);
      });
      callback();
      handleOpenPopup(!isOpenPopup, null);
    }
  };

  const addOrEdit = (IotCallingCampaign, resetForm) => {
    if (!IotCallingCampaign.id) {
      createIotCallingCampaign(IotCallingCampaign, (result) => {
        actionAfterCreateOrUpdate(result, resetForm);
      });
    } else {
      updateIotCallingCampaign(
        IotCallingCampaign.id,
        IotCallingCampaign,
        (result) => {
          actionAfterCreateOrUpdate(result, resetForm);
        }
      );
    }
  };

  const handleDelete = (iotCallingCampaignDeleted) => {
    NotifyConfirm("warning", "Are you delete it ?", (result) => {
      if (result.isConfirmed) {
        const foundIotCallingCampaignIndex =
          iotCallingCampaignData.list.findIndex(
            (iotCallingCampaign) =>
              iotCallingCampaign.id === iotCallingCampaignDeleted.id
          );
        if (foundIotCallingCampaignIndex !== -1) {
          removeIotCallingCampaign(iotCallingCampaignDeleted.id);
          iotCallingCampaignData.list.splice(foundIotCallingCampaignIndex, 1);
          setIotCallingCampaignData((prev) => {
            return {
              ...prev,
              list: [...iotCallingCampaignData.list],
              total_record: prev.total_record - 1,
            };
          });
          setFilterIotCallingCampaigns([...iotCallingCampaignData.list]);
        }
      }
    });
  };

  const handleOpenPopup = (isOpen, item) => {
    setOpenPopup(isOpen);
    setRecordForEdit(item);
    setErrorsForm({});
  };

  return (
    <div>
      <div className="page-header">
        <h2>{titlePage}</h2>
      </div>

      <IotCallingPopupCampaign
        recordForEdit={recordForEdit}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        addOrEdit={addOrEdit}
        errorsForm={errorsForm}
      />

      <IotCallingCampaignControlPanel
        permissionsAccessControl={permissionsAccessControl}
        handleOpenPopup={handleOpenPopup}
      >
        <ControlPanelSystem
          searchKey={searchKey}
          handleInputChange={(e) => handleInputChange(e)}
          limit={limit}
          setLimit={setLimit}
          setNumberPage={setNumberPage}
          status={status}
          setStatus={setStatus}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      </IotCallingCampaignControlPanel>

      <IotCallingCampaignTable
        permissionsAccessControl={permissionsAccessControl}
        data={filterIotCallingCampaigns}
        handleOpenPopup={handleOpenPopup}
        handleDelete={handleDelete}
        status={status}
      />

      <Pagination
        pathname={path.cmsIotCallingCampaign}
        page={numberPage}
        handleChangePage={(page) => handleChangePage(page)}
        limit={limit}
        pageSize={iotCallingCampaignData.total_record}
      />
    </div>
  );
};

export default IotCallingCampaign;
